




















































































import {
  defineComponent,
  computed,
} from '@vue/composition-api';
import {
  NOW,
  NOW_START_YEAR,
  NOW_START_MONTH,
  NOW_END_MONTH,
  toCommaFormat,
} from '@/utils';

import { useMutation, useQuery } from '@vue/apollo-composable';

import ChartWithLastYearCompare from '@/components/Report/ChartWithLastYearCompare.vue';
import ChartWithSelectedMonth from '@/components/Report/ChartWithSelectedMonth.vue';
import DoughnutHub from '@/components/Report/01-Income/DoughnutHub.vue';
import SmallChartPanel from '@/components/Report/SmallChartPanel.vue';
import TreemapAreaExpense from '@/components/Report/02-Expense/TreemapAreaExpense.vue';

import netProfitStats from '@/gql/managementReport/03-Profit/netProfitStats.gql';
import monthsNetProfit from '@/gql/managementReport/03-Profit/monthsNetProfit.gql';
import netProfitRange from '@/gql/managementReport/03-Profit/netProfitRange.gql';
import hubsNetProfit from '@/gql/managementReport/03-Profit/hubsNetProfit.gql';
import areasNetProfit from '@/gql/managementReport/03-Profit/areasNetProfit.gql';

const DeliveryProfit = defineComponent({
  components: {
    SmallChartPanel,
    ChartWithLastYearCompare,
    ChartWithSelectedMonth,
    DoughnutHub,
    TreemapAreaExpense,

  },
  setup() {
    const { result: getTopInfo } = useQuery(netProfitStats, computed(() => ({
      timeframe: { from: NOW_START_YEAR, to: NOW },
      timeframeY1: { from: NOW_START_MONTH, to: NOW },
    })));
    const getPanelInfo = computed(() => getTopInfo.value?.netProfitStats || {});
    const getPanelInfoMtd = computed(() => getTopInfo.value?.netProfitStatsMTD || {});

    return {
      netProfitStats,
      monthsNetProfit,
      netProfitRange,
      hubsNetProfit,
      areasNetProfit,

      getPanelInfo,
      getPanelInfoMtd,
    };
  },
});

export default DeliveryProfit;
